<template>
  <div class="block py-24 sm:py-48">
    <div class="container px-0 md:hidden">
      <div
        class="
          swiper-container swiper-articles
          pr-24
          sm:pr-56
          md:pr-0
          ml-0
          pl-24
          sm:pl-56
          md:pl-0
        "
        itemscope
        itemtype="https://schema.org/ItemList"
      >
        <ArticleListingContent
          class="swiper-wrapper w-auto -mx-6"
          slide-class="swiper-slide w-11/12 px-6 sm:w-1/2"
          :component="component"
          :show-excerpt="showExcerpt"
        />
      </div>
    </div>
    <div class="container hidden md:block md:px-56 xxl:px-24">
      <ArticleListingContent
        class="grid grid-cols-3 gap-24"
        slide-class=""
        :component="component"
        :show-excerpt="showExcerpt"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Swiper from 'swiper';
import ComponentBlock from '~/models/component-block';
import ArticleListingContent from '~/components/blocks/ArticleListingContent.vue';

import { defineComponent } from 'vue';

export default defineComponent({
  components: { ArticleListingContent },
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
    showExcerpt: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      swiper: null as Swiper | null,
    };
  },
  computed: {},
  updated() {
    this.swiper && this.swiper.update();
  },
  unmounted() {
    this.swiper && this.swiper.destroy(true, true);
  },
  mounted() {
    this.swiper = new Swiper('.swiper-articles', {
      loop: false,
      slidesPerView: 'auto',
      noSwiping: true,
      breakpoints: {
        1024: {
          simulateTouch: false,
          allowTouchMove: false,
        },
      },
    });
  },
  methods: {},
});
</script>
